import { FC, ReactNode, createContext, useCallback, useContext, useMemo, useState } from 'react'

interface ActionsContextValue {
    set: (cartItemId: string, productId: string) => void
    unset: () => void
}

type ContextValue = {
    cartItemId: string
    productId: string
} | null

const Context = createContext<ContextValue>(null)

const ActionsContext = createContext<ActionsContextValue>({
    set: () => {},
    unset: () => {},
})

interface EditCartItemProviderProps {
    children: ReactNode
}

const EditCartItemProvider: FC<EditCartItemProviderProps> = ({ children }) => {
    const [ids, setIds] = useState<ContextValue>(null)

    const set = useCallback(
        (cartItemId: string, productId: string) => setIds({ cartItemId, productId }),
        []
    )

    const unset = useCallback(() => setIds(null), [])

    const actions = useMemo(() => ({ set, unset }), [set, unset])

    return (
        <Context.Provider value={ids}>
            <ActionsContext.Provider value={actions}>{children}</ActionsContext.Provider>
        </Context.Provider>
    )
}

export default EditCartItemProvider

export const useEditCartItem = (): ContextValue => useContext(Context)

export const useEditCartItemActions = (): ActionsContextValue => useContext(ActionsContext)
